import { useState, useEffect } from "react";
import styles from "./Contact.module.css";

const SOCIAL_LINKS = [
  {
    id: "linkedin",
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/harsh-gyanchandani-9a64b01b2/",
  },
  {
    id: "gmail",
    name: "GMail",
    link: "mailto:harsh.gyanchandani@gmail.com",
  },
  {
    id: "instagram",
    name: "Instagram",
    link: "https://instagram.com/igyanchandani",
  },
  {
    id: "facebook",
    name: "Facebook",
    link: "https://facebook.com/harsh.gyanchandani.98",
  },
];

const Contact = (props) => {
  const [visible, setIsVisible] = useState(false);
  const { scrollOffset } = props;

  useEffect(() => {
    const bodyRect = document.body.getBoundingClientRect();
    const elementRect = document
      .getElementsByClassName(styles["contact"])[0]
      .getBoundingClientRect();

    const offset = elementRect.top - bodyRect.top;

    const elementVisible = scrollOffset + window.innerHeight - offset;
    const elementSize = elementRect.bottom - elementRect.top;

    if (elementVisible >= elementSize / 2) setIsVisible(true);
    else setIsVisible(false);
  }, [scrollOffset]);

  const socialLinks = SOCIAL_LINKS.map((link) => {
    return (
      <li key={link.id}>
        <a rel="noreferrer" href={link.link} target="_blank">
          <img
            src={require(`../../assets/icons/${link.id}.svg`)}
            alt={link.name}
          />
        </a>
      </li>
    );
  });

  return (
    <div className={styles["contact"]}>
      <ul className={`${styles["list"]} ${!visible && styles["list--hidden"]}`}>
        {socialLinks}
      </ul>
      <div
        className={`${styles["heading"]} ${
          !visible && styles["heading--hidden"]
        }`}>
        <h1>GET IN TOUCH</h1>
        <p>
          Interested in working together? My door is always open for
          collaborations and opportunities. Feel free to drop me a line. Please
          allow a couple of days for me to respond, I'll get back to you as soon
          as I can.
        </p>
      </div>
    </div>
  );
};

export default Contact;
